import {browserHistory} from 'react-router';
import _ from 'lodash';
import {
    JEWELRY_FOR_EXPERIMENTS, p13nServiceDecisions,
} from 'helpers/ApplicationHelper';
import {DEFAULT_PHONE} from '../constants/register';

// no_estimation has been removed by WORTHY-6134
const ACTIVE_EXPERIMENTS = ['skip_schedule_appointment_exp'];

export default class experiments {
    constructor(experiments) {
        this.experiments = experiments || null;
    }

    chatBotExperimentTest(type, ado, item, p13n) {
        if (this.experiments === null) {
            return null;
        }
        let res = 0;
        const user = ado.user
        const experiments = this.experiments
        const itemTypeInExperiments = item && JEWELRY_FOR_EXPERIMENTS.includes(item.item_type)
        const isHybridCui = p13n && [p13nServiceDecisions.hybridHvCui, p13nServiceDecisions.hybridCui].includes(p13n.preShipmentUi)
        const isOptionalPhone = itemTypeInExperiments && ((user.phone === DEFAULT_PHONE) || !!user.phone_invalid)
        const isJbExp = _.get(experiments, 'jb_cui.status', false) && _.get(experiments, 'jb_cui.variant', false) === "true"

        // The unary + operator precedes its operand and evaluates to its operand but attempts to convert it into a number, if it isn't already.
        switch (type) {
            case 'missingDetails':
                break;
            case 'highValue':
                res = + isHybridCui
                break;
            case 'jewelryBox':
                res = + isJbExp
                break;
            case 'watch':
                res = + item.has_submission_photo // isWatchPhotoSubmitted
                break;
            case 'standard':
            case 'default':
                // for necklace or bracelet
                if(!isHybridCui)
                    res = 2
                else
                    res = + isOptionalPhone // user has a valid phone
                break;
        }
        return res;
    }

    static initAppExperimentsFromQuery(location, setExperiment) {
        var locationQuery = location.query,
            pendingExperiments = {};

        _.each(ACTIVE_EXPERIMENTS, (experiment) => {
            if (locationQuery[experiment]) {
                pendingExperiments[experiment] = true;
                delete locationQuery[experiment]
            }
        });

        if (!_.isEmpty(pendingExperiments)) {
            // cookie.save('pending_experiments', pendingExperiments, {expires: new Date(new Date().setYear(new Date().getFullYear() + 1))});
            browserHistory.replace(location.pathname + (_.isEmpty(location.query) ? '' : `?${this._arrayToQueryString(locationQuery)}`));
            setExperiment(pendingExperiments);
        }
    }

    static _arrayToQueryString(arr) {
        var str = '';
        _.map(arr, (value, key) => {
            str += `${key}=${value}&`
        });
        return str.slice(0, -1);
    }
}
